import { getCurrentScope, onScopeDispose, unref, watch } from 'vue'
import { NOOP } from '@lit-element/utils'
import type { Ref } from 'vue'

export function useListener<E = Event>(
  target: Ref<HTMLElement | null | undefined>, //EventTarget | null | undefined,
  event: string,
  listener: (event: E) => any,
  options?: AddEventListenerOptions | boolean
) {
  if (!target) {
    return NOOP
  }

  let remove = NOOP

  const stopWatch = watch(
    () => unref(target),
    (el) => {
      remove()

      if (!el) {
        return
      }

      el.addEventListener(event, listener as any, options)

      remove = () => {
        el.removeEventListener(event, listener as any, options)
        remove = NOOP
      }
    },
    { immediate: true, flush: 'post' }
  )

  const stop = () => {
    stopWatch()
    remove()
  }

  getCurrentScope() && onScopeDispose(stop)

  return stop
}
